const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Angel
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel',
    name: 'angel-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Angel',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Angel !<br />Un style manuscrit, avec des pleins et des déliés élégants.<br />La police d'écriture Angel a l’avantage de ne pas avoir de ligatures entre les lettres, ce qui lui confère un aspect plus harmonieux lors d’une utilisation à la réglette.",
      tags: ['set-tampon-alphabet-angel'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/angel/set-complet-angel.jpg'),
          name: 'Angel',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/set-complet-angel',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/angel/angel-majuscules.jpg'),
          name: 'Angel',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/majuscules-angel',
        },
        {
          src: require('../../../public/img/materiel-creatif/angel/angel-minuscules.jpg'),
          name: 'Angel',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/minuscules-angel',
        },
        {
          src: require('../../../public/img/materiel-creatif/angel/angel-speciaux.jpg'),
          name: 'Angel',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/speciaux-chiffres-angel',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/set-complet-angel',
    name: 'full-set-angel',
    component: () =>
      import('../../pages/products/creative/Angel/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/angel/set-complet-angel.jpg'),
      type: 'Set complet Angel',
      hiddenType: 'angel-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-angel'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/majuscules-angel',
    name: 'uppercase-angel',
    component: () =>
      import('../../pages/products/creative/Angel/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/angel/angel-majuscules.jpg'),
      type: 'Jeu de majuscules Angel',
      hiddenType: 'angel-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-angel'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/minuscules-angel',
    name: 'lowercase-angel',
    component: () =>
      import('../../pages/products/creative/Angel/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/angel/angel-minuscules.jpg'),
      type: 'Jeu de minuscules Angel',
      hiddenType: 'angel-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-angel'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel/speciaux-chiffres-angel',
    name: 'specials-numbers-angel',
    component: () =>
      import('../../pages/products/creative/Angel/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/angel/angel-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Angel',
      hiddenType: 'angel-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-angel'],
    },
  },
];
